import ReactOnRails from 'react-on-rails';

import FAQ from '../src/Common/FAQ';

import OnboardingAgentProfileWizard from '../src/Onboarding/AgentProfileWizard';

import Messages from '../src/Agent/Messages';

import CopilotProfile from '../src/Common/CopilotProfile/CopilotProfile';

import AdminAgentList from '../src/Admin/AgentList';
import AdminCopilotApplicationList from '../src/Admin/CopilotApplicationList';
import AdminCopilotIndividualList from '../src/Admin/CopilotIndividualList';
import AdminCrmPersonDetails from '../src/Admin/Crm/PersonDetails';
import AdminBlogPostManager from '../src/Admin/BlogPostManager';
import AdminDemoMeetingList from '../src/Admin/Demos/MeetingList';
import AdminDemoDetails from '../src/Admin/Demos/DemoDetails';

import BlogAllPosts from '../src/Blog/AllPosts';

import AgentAccountProfile from '../src/Agent/Account/AboutMe';
import AgentEditSubscriptionButton from '../src/Agent/Account/EditSubscriptionButton';
import AgentPaymentMethods from '../src/Agent/PaymentMethods';
import AgentNewRequest from '../src/Agent/NewRequest';
import AgentEditRequest from '../src/Agent/EditRequest';
import AgentRequests from '../src/Agent/Requests';
import AgentStandaloneRequestCards from '../src/Agent/StandaloneRequestCards';
import AgentProjectRequestDetails from '../src/Agent/ProjectRequestDetails';
import AgentHourlyRequestDetails from '../src/Agent/HourlyRequestDetails';
import AgentCopilotPreferencesWizard from '../src/Agent/PreferenceWizard';
import AgentBestMatchCopilots from '../src/Agent/BestMatchCopilots';
import { CopilotSearchSort as AgentCopilotSearchSort } from '../src/Agent/Components/CopilotSearchSort';
import AgentStandaloneCopilotCards from '../src/Agent/StandaloneCopilotCards';
import AgentReassignRequest from '../src/Agent/ReassignRequest';
import AgentPackageGrid from '../src/Agent/PackageGrid';
import AgentPackagePurchase from '../src/Agent/PackagePurchase';
import AgentRetainerCheckout from '../src/Agent/RetainerCheckout';

import CopilotAccountProfile from '../src/Copilot/Account/Profile';
import CopilotAccountSchedulingCalendars from '../src/Copilot/Account/Scheduling/Calendars';
import CopilotAccountSchedulingOfficeHours from '../src/Copilot/Account/Scheduling/OfficeHours';
import CopilotEditProfile from '../src/Common/CopilotProfile/EditProfile';
import CopilotAccountPackages from '../src/Copilot/Account/Packages';
import CopilotRequests from '../src/Copilot/Requests';
import CopilotProjectRequestDetails from '../src/Copilot/ProjectRequestDetails';
import CopilotHourlyRequestDetails from '../src/Copilot/HourlyRequestDetails';
import CopilotInterviewBookInterview from '../src/Copilot/Interview/BookInterview';
import CopilotInterviewRescheduleInterview from '../src/Copilot/Interview/RescheduleInterview';

import DemoBookDemo from '../src/Demo/BookDemo';
import DemoRescheduleDemo from '../src/Demo/RescheduleDemo';

import { LandingPage as LeadMagnetLandingPage, Modal as LeadMagnetModal } from '../src/Marketing/LeadMagnet';

import LivestreamEventDetail from '../src/Livestream/EventDetail';
import { EventCard as LivestreamEventCard } from '../src/Livestream/EventCard';
import LivestreamEventGrid from '../src/Livestream/EventGrid';

// Any component referenced via a Rails call to `react_component` must be defined here, as well as in `server-bundle.js`.
ReactOnRails.register({
  FAQ,

  OnboardingAgentProfileWizard,

  Messages,

  CopilotProfile,

  AdminAgentList,
  AdminCopilotApplicationList,
  AdminCopilotIndividualList,
  AdminCrmPersonDetails,
  AdminBlogPostManager,
  AdminDemoMeetingList,
  AdminDemoDetails,

  BlogAllPosts,

  AgentAccountProfile,
  AgentEditSubscriptionButton,
  AgentPaymentMethods,
  AgentNewRequest,
  AgentEditRequest,
  AgentRequests,
  AgentStandaloneRequestCards,
  AgentProjectRequestDetails,
  AgentHourlyRequestDetails,
  AgentCopilotPreferencesWizard,
  AgentBestMatchCopilots,
  AgentCopilotSearchSort,
  AgentStandaloneCopilotCards,
  AgentReassignRequest,
  AgentPackageGrid,
  AgentPackagePurchase,
  AgentRetainerCheckout,

  CopilotAccountProfile,
  CopilotAccountSchedulingCalendars,
  CopilotAccountSchedulingOfficeHours,
  CopilotEditProfile,
  CopilotAccountPackages,
  CopilotRequests,
  CopilotProjectRequestDetails,
  CopilotHourlyRequestDetails,
  CopilotInterviewBookInterview,
  CopilotInterviewRescheduleInterview,

  DemoBookDemo,
  DemoRescheduleDemo,

  LeadMagnetLandingPage,
  LeadMagnetModal,

  LivestreamEventDetail,
  LivestreamEventCard,
  LivestreamEventGrid
});
